import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { MainLayout } from '../components/layout';
import Content from '../components/Content';
import { Equipment } from '../components/equipment';
import { Person } from '../components/person';
import Device from '../components/Device';
import Hardware from '../components/Hardware';
import { EquipmentGroup } from '../components/equipment-group';
import { Crew } from '../components/crew';
import { Settings } from '../components/all-settings';
import { OrganizationConfiguration } from '../components/organization';
import Chat from '../components/chat/NewChat';
import { Dashboard } from '../components/dashboard';
import { getUserId } from '../helpers/session';
import { connectXMPP, disconnectXMPP } from '../actions/chat';
import { Farm } from '../components/farm';
import { FarmMonitor } from '../components/FarmMonitor';
import Users from '../components/Users/Users';
import GeoShape from '../components/GeoShape/GeoShape';
import OrganizationList from '../components/organization/OrganizationList';
import BoardList from '../components/board/BoardList';
import { QRGenerator } from '../components/qrcode/QRGenerator';
import { SclaeWeight } from '../components/scale/sclaeWeight';
import MessageAlert from '../components/settings/messagePolicy/MessageAlert';
import { Network } from '../components/network';
import ScoutObservation from '../components/ScoutObservation';
import { ScoutKanban } from '../components/scout-kanban';

const Home = ({ match }) => {
  
  const dispatch = useDispatch();
  const range = useSelector(state => state.analyze.searchParams.range);
  useEffect(() => {
    const hubspotElement = document.querySelector("#hubspot-messages-iframe-container.widget-align-right");
    if (hubspotElement) hubspotElement.classList.add("hubspot-right");

    // Connect to xmpp client
    dispatch(connectXMPP(getUserId(), match.params.farmId));

    return () => {
      // Cleanup: disconnect from XMPP
      dispatch(disconnectXMPP());
    };
  }, [match.params.farmId]);

  return (
    <MainLayout match={match}>
      {range && (
        <>
          <Route path={`${match.path}/farm-monitor`} component={FarmMonitor} />
          <Route path={`${match.path}/dashboard`} component={Dashboard} />
          <Route path={`${match.path}/map`} component={Content} />
          <Route path={`${match.path}`} component={Farm} />
          <Route path={`${match.path}/users`} component={Users} />
          <Route path={`${match.path}/equipment`} component={Equipment} />
          <Route path={`${match.path}/person`} component={Person} />
          <Route path={`${match.path}/device`} component={Device} />
          <Route path={`${match.path}/network`} component={Network} />
          <Route path={`${match.path}/device-console`} component={Hardware} />
          <Route path={`${match.path}/eg`} component={EquipmentGroup} />
          <Route path={`${match.path}/crew`} component={Crew} />
          <Route path={`${match.path}/settings`} component={Settings} />
          <Route path={`${match.path}/message/alert`} component={MessageAlert} />
          <Route path={`${match.path}/organizationconfig`} component={OrganizationConfiguration} />
          <Route path={`${match.path}/observation`} component={ScoutObservation} />
          <Route path={`${match.path}/chat`} component={Chat} />
          <Route path={`${match.path}/shape`} component={GeoShape} />
          <Route path={`${match.path}/organization`} component={OrganizationList} />
          <Route path={`${match.path}/board`} component={BoardList} />
          <Route path={`${match.path}/qrcode`} component={QRGenerator} />
          <Route path={`${match.path}/scale`} component={SclaeWeight} />
          <Route path={`${match.path}/scout`} component={ScoutKanban} />
        </>
      )}
    </MainLayout>
  );
};
export default memo(Home);
